import moment from "moment";
import useUrlState from "../../../hooks/useUrlState";

type DateFilter = [Date | null, Date | null];

export type LaporanTabKey =
    | "invoice"
    | "mutasi"
    | "stokTerjual"
    | "pengeluaran"
    | "labaRugi";

const VALID_TAB_KEYS: LaporanTabKey[] = [
    "invoice",
    "mutasi",
    "stokTerjual",
    "pengeluaran",
    "labaRugi",
];

const todayApi = () => moment().format("YYYY/MM/DD");

const dateSchema = (defaultFn: () => string) => ({
    defaultValue: defaultFn(),
    parse: (raw: string): string | null => {
        const m = moment(raw, "YYYY-MM-DD", true);
        return m.isValid() ? m.format("YYYY/MM/DD") : null;
    },
    serialize: (value: string) =>
        moment(value, "YYYY/MM/DD").format("YYYY-MM-DD"),
});

const schema = {
    tanggalAwal: dateSchema(todayApi),
    tanggalAkhir: dateSchema(todayApi),
    tab: {
        defaultValue: "" as LaporanTabKey | "",
        parse: (raw: string): LaporanTabKey | "" | null =>
            VALID_TAB_KEYS.includes(raw as LaporanTabKey)
                ? (raw as LaporanTabKey)
                : null,
        serialize: (value: LaporanTabKey | "") => value,
    },
};

export default function useLaporanFilters() {
    const [urlState, setUrlState] = useUrlState(schema);

    const dateRange: DateFilter = [
        moment(urlState.tanggalAwal, "YYYY/MM/DD").toDate(),
        moment(urlState.tanggalAkhir, "YYYY/MM/DD").toDate(),
    ];

    const setDateRange = (update: DateFilter) => {
        if (update[0] && update[1]) {
            setUrlState({
                tanggalAwal: moment(update[0]).format("YYYY/MM/DD"),
                tanggalAkhir: moment(update[1]).format("YYYY/MM/DD"),
            });
        }
    };

    return {
        tanggalAwal: urlState.tanggalAwal,
        tanggalAkhir: urlState.tanggalAkhir,
        dateRange,
        setDateRange,
        tabSlug: urlState.tab,
        setTabSlug: (slug: LaporanTabKey | "") => setUrlState({ tab: slug }),
    };
}
